import { useEffect } from 'react'
import { Outlet, ScrollRestoration } from 'react-router-dom'

/**
 * Port of Views/Shared/_LoginLayout.cshtml — the centred card the Account pages
 * render into.
 *
 * The original was a full HTML document with its own <head>. There is one
 * document now, so the auth-only stylesheets it added
 * (ladda-themeless.min.css, the Public Sans webfont) are the only difference;
 * ladda is gone with the spinner library it themed, and the font is already
 * pulled in by style.css.
 *
 * `data-pc-sidebar-theme="light"` is set here because the auth pages set it on
 * <body> while _Layout did not.
 */
export function LoginLayout(): JSX.Element {
  useEffect(() => {
    const body = document.body
    const previous = body.getAttribute('data-pc-sidebar-theme')
    body.setAttribute('data-pc-sidebar-theme', 'light')
    // The landing-page class styles the marketing nav, which these pages have
    // no navbar for; leaving it on adds its top padding to the centred card.
    body.classList.remove('landing-page')

    window.layout_change?.('light')
    window.layout_sidebar_change?.('light')
    window.change_box_container?.('false')
    window.layout_caption_change?.('true')
    window.layout_rtl_change?.('false')
    window.preset_change?.('preset-1')

    return () => {
      if (previous === null) body.removeAttribute('data-pc-sidebar-theme')
      else body.setAttribute('data-pc-sidebar-theme', previous)
      body.classList.add('landing-page')
    }
  }, [])

  useEffect(() => {
    window.feather?.replace()
  })

  return (
    <div className="auth-main v1">
      {/* Same reason as AppLayout: land at the top of each new page. */}
      <ScrollRestoration />
      <div className="auth-wrapper">
        <div className="auth-form">
          <div className="card my-5">
            <div className="card-body">
              <Outlet />
            </div>
          </div>
        </div>
        <div className="auth-sidefooter">
          <hr className="mb-3 mt-4" />
          <div className="row">
            <div className="col my-1">
              <p className="m-0">E-Career &copy; {new Date().getFullYear()}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
